<template>
  <div class="coach-select-box">
    <div v-for="(list, index) in coachSelectVOForm" :key="index" class="flex" style="margin-bottom: 10px;">
      <el-select v-model="coachSelectVOForm[index].level" popper-class="_coach-level_" placeholder="请选择教练级别" style="margin-right: 20px" @change="handleCoachSelectChange(index)">
        <el-option v-for="item in coachLevels" :key="item.level" :label="item.level" :value="item.id" />
      </el-select>
      <el-select v-model="coachSelectVOForm[index].id" popper-class="_coach-name_" placeholder="请选择教练名称" :disabled="disabled" @change="coachSelectChange">
        <el-option v-for="it in coachSelectVO[coachSelectVOForm[index].level]" :key="it.id" :label="it.firstName + it.lastName" :value="it.id" />
      </el-select>
      <template v-if="coachSelectVOForm.length===1">
        <div class="btn-reset" @click="handleReset">重置</div>
      </template>
      <div v-if="index !== 0 && coachSelectVOForm[index].level !== null" class="form-icon" @click="handleRemoveCoach(index)">
        <el-icon class="el-icon-close" />
      </div>
    </div>
    <div class="form-add" :class="disabled ? 'disabled' : ''">
      <el-button icon="el-icon-plus" @click="handleAddCoach">添加活动教练</el-button>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isNeedCoach: {
      type: Number,
      default: 0, // 0需要教练，1不需要教练
    },
  },
  data() {
    return {
      disabled: false,
      coachSelectVOForm: [{
        id: "",
        level: "",
        firstName: "",
        lastName: "",
        time: Date.parse(new Date()),
      }],
      coachSelectVOList: [],
    };
  },
  computed: {
    coachSelectVO() {
      return this.$store.state.activity.coachSelectVO.reduce((pre, current) => {
        if (!pre[current.level]) {
          pre[current.level] = [];
        }
        pre[current.level].push(current);
        return pre;
      }, {});
    },
    coachLevels() {
      return this.$store.state.activity.coachLevels.length ? [{ id: 0, level: "无教练" }, ...this.$store.state.activity.coachLevels] : [{ id: 0, level: "无教练" }];
    },
    coachSelectList() {
      return this.$store.state.activity.coachSelectVO.reduce((pre, current) => {
        if (pre.findIndex(item => item.level === current.level) === -1) {
          pre.push(current);
        }
        return pre;
      }, []);
    },
    ids() {
      return this.coachSelectVOForm.map(item => item.id);
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val && val.length) {
          this.coachSelectVOForm = [].concat(val);
        }
      },
      deep: true,
      immediate: true,
    },
    isNeedCoach: {
      handler(val) {
        if (val) {
          this.coachSelectVOForm.splice(0, 1);
          this.coachSelectVOForm.unshift({
            id: "",
            level: 0,
            firstName: "",
            lastName: "",
            time: Date.parse(new Date()),
          });
          this.handleCheckDisabled();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleReset() {
      this.coachSelectVOForm = [{
        id: "",
        level: "",
        firstName: "",
        lastName: "",
        time: Date.parse(new Date()),
      }];
      this.handleCheckDisabled();
      this.$emit('change', this.coachSelectVOForm);
    },
    handleRemoveCoach(index) {
      this.coachSelectVOForm.splice(index, 1);
      this.handleCheckDisabled();
      this.$emit('change', this.coachSelectVOForm);
      this.$parent.$emit("el.form.change");
    },
    handleAddCoach() {
      if (this.disabled) return;
      this.coachSelectVOForm.push({
        id: "",
        level: "",
        firstName: "",
        lastName: "",
        time: Date.parse(new Date()),
      });
      this.$emit('change', this.coachSelectVOForm);
    },
    coachSelectChange(id) {
      this.$emit('change', this.coachSelectVOForm);
    },
    handleCheckDisabled() {
      const len = this.coachSelectVOForm.filter(item => item.level === 0);
      this.disabled = len.length > 0;
      this.$emit('changeDisabled', this.disabled);
    },
    handleCoachSelectChange(index) {
      this.handleCheckDisabled();
      this.coachSelectVOForm.forEach((item, i) => {
        if (i === index) {
          item.id = '';
        }
      });
      this.$emit('change', this.coachSelectVOForm);
    },
  },
};
</script>

<style lang="less" scoped>
.coach-select-box {
  .form-add.disabled {
    .el-button {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      cursor: not-allowed;
    }
  }
}
</style>
